export const buildShareUserSearchParams = (page: number, perPage: number, query: string) => ({
  page,
  per_page: perPage,
  q: query.trim(),
  exclude_self: true,
});

export const mapShareUsers = (users: ShareUser[]) => users.map((user) => ({
  id: String(user.id),
  name: user.name,
  company: user.company,
  email: user.email,
}));
